export interface IEmailTemplateForgotPassword {
  subject: string;
  header_text: string;
  footer_text: string;
  email_has_been_sent_phrase: string;
  reset_your_password_phrase: string;
}
